import React from "react";
import { InputFabric } from "@msidentity/SISU/components/inputs/input/fabric/input-fabric";
import { LinkButton } from "@msidentity/SISU/components/link-button";
import { ViewContainerFabric } from "@msidentity/sisu/components/view-container/fabric/view-container-fabric";
import { FlowId, ViewId } from "@msidentity/sisu/constants/routing-constants";
import { useDocumentTitle } from "@msidentity/SISU/hooks";
import { useActivateView } from "@msidentity/sisu/hooks/use-activate-view";
import { useLinkButtonStylesFabric } from "@msidentity/SISU/styles/fabric";
import { commonBindingsFabric } from "@msidentity/SISU/utilities/formatted-text-with-bindings";
import { replaceTokens } from "@msidentity/SISU/utilities/strings-helper";
import {
  usernameRecoveryEnterCodeViewStringsFabric,
  usernameRecoveryGenericStringsFabric as strings,
} from "../../../fabric/username-recovery-strings-fabric";
import { useUsernameRecoveryEnterCode } from "../../../hooks/use-username-recovery-enter-code";
import UsernameRecoveryConfig from "../../../username-recovery-config";

/**
 * Legacy Email and SMS code component
 * @returns instance of the component
 */
export const EnterCodeViewFabric: React.FC = function EnterCodeViewFabric() {
  useActivateView(ViewId.UsernameRecoveryLegacyCode, FlowId.UsernameRecovery, {
    showBackButtonOnActiveView: false,
    showIdentityBanner: false,
  });
  useDocumentTitle(usernameRecoveryEnterCodeViewStringsFabric.enterCodeTitle);

  const { strong } = commonBindingsFabric;

  const { allowProofBasedSignIn } = UsernameRecoveryConfig.instance;

  const descriptionString = allowProofBasedSignIn
    ? usernameRecoveryEnterCodeViewStringsFabric.hasAlternateAccountDescription
    : usernameRecoveryEnterCodeViewStringsFabric.enterCodeDescription;

  const {
    inputProps,
    onSubmit,
    onBack,
    onCancelHandler,
    usernameDisplay,
    displaySwitchLink,
    secondaryButtonText,
  } = useUsernameRecoveryEnterCode();
  const { anchorNoFocus } = useLinkButtonStylesFabric();

  return (
    <ViewContainerFabric
      applyAriaLive
      title={{
        title: usernameRecoveryEnterCodeViewStringsFabric.enterCodeTitle,
      }}
      primaryButton={{
        label: strings.next,
        type: "submit",
        hasFocus: false,
      }}
      secondaryButton={{
        label: secondaryButtonText,
        type: "button",
        hasFocus: false,
        onClick: onCancelHandler,
      }}
      description={{
        description: replaceTokens(descriptionString, usernameDisplay),
        embeddedBindings: { username: strong },
      }}
      form={{
        onSubmit,
      }}
    >
      <InputFabric
        id="enter-code-input"
        name="enter-code-input"
        type="phone"
        placeholder={usernameRecoveryEnterCodeViewStringsFabric.enterCodePlaceholder}
        hasInitialFocus
        onChange={inputProps.onChange}
        value={inputProps.value}
        onFocus={inputProps.onFocus}
        onBlur={inputProps.onBlur}
        hasFocus={inputProps.hasFocus}
        errorMessage={inputProps.error.errorMessage}
        showErrorMessage={inputProps.error.showErrorMessage}
      />
      {displaySwitchLink && (
        <div>
          <LinkButton
            className={anchorNoFocus}
            onClick={onBack}
            text={usernameRecoveryEnterCodeViewStringsFabric.enterDifferentProofLink}
            linkDataTestId="enter-different-proof-link"
          />
        </div>
      )}
    </ViewContainerFabric>
  );
};
